const API_BASE = process.env.REACT_APP_API_URL || 'https://api.grandindigoembroidery.com';

const headers = () => ({
  'Content-Type': 'application/json',
  'Accept': 'application/json',
});

/**
 * Submit the contact form
 * @param {{ firstName, lastName, email, phone, comments }} payload
 */
export const submitContactForm = async (payload) => {
  const res = await fetch(`${API_BASE}/contact`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  if (!res.ok) {
    if (data.errors) {
      const first = Object.values(data.errors)[0];
      throw new Error(Array.isArray(first) ? first[0] : first);
    }
    throw new Error(data.message || 'Failed to send message.');
  }
  return data;
};